import React from 'react';
import PropTypes from 'prop-types';

const ImpuestosComplemento = ({ impuestos }) => {
    const hasTraslados = impuestos?.trasladosP && impuestos.trasladosP.length > 0;
    const hasRetenciones = impuestos?.retencionesP && impuestos.retencionesP.length > 0;

    if (!hasTraslados && !hasRetenciones) return null;

    return (
        <div className="mb-4">
            <h6 className="fw-bold mb-3 border-bottom pb-2">IMPUESTOS DEL PAGO</h6>
            
            <div className="p-3 border rounded bg-light" style={{ transition: 'all 0.2s ease' }}>
                
                {hasTraslados && (
                    <div className="mb-2">
                        <span className="text-muted fw-bold d-block mb-2" style={{ fontSize: '0.8rem' }}>TRASLADOS:</span>
                        {impuestos.trasladosP.map((imp, idx) => (
                            <div key={`tp-${idx}`} className="d-flex flex-wrap gap-3 mb-2" style={{ fontSize: '0.85rem' }}>
                                <div><span className="text-muted">Impuesto:</span> <span className="fw-bold">{imp.ImpuestoP}</span></div>
                                <span className="text-muted">|</span>
                                <div><span className="text-muted">Base:</span> <span className="fw-bold">${imp.BaseP}</span></div>
                                <span className="text-muted">|</span>
                                <div><span className="text-muted">Tipo Factor:</span> <span className="fw-bold">{imp.TipoFactorP}</span></div>
                                <span className="text-muted">|</span>
                                <div><span className="text-muted">Tasa/Cuota:</span> <span className="fw-bold">{imp.TasaOCuotaP}</span></div>
                                <span className="text-muted">|</span>
                                <div><span className="text-muted">Importe:</span> <span className="fw-bold text-dark">${imp.ImporteP}</span></div>
                            </div>
                        ))}
                    </div>
                )}

                {hasRetenciones && (
                    <div className={`pt-2 ${hasTraslados ? 'border-top mt-2' : ''}`}>
                        <span className="text-muted fw-bold d-block mb-2" style={{ fontSize: '0.8rem' }}>RETENCIONES:</span>
                        {impuestos.retencionesP.map((ret, idx) => (
                            <div key={`rp-${idx}`} className="d-flex flex-wrap gap-3 mb-2" style={{ fontSize: '0.85rem' }}>
                                <div><span className="text-muted">Impuesto:</span> <span className="fw-bold">{ret.ImpuestoP}</span></div>
                                <span className="text-muted">|</span>
                                <div><span className="text-muted">Importe:</span> <span className="fw-bold text-danger">${ret.ImporteP}</span></div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

ImpuestosComplemento.propTypes = {
    impuestos: PropTypes.shape({
        trasladosP: PropTypes.array,
        retencionesP: PropTypes.array
    })
};

export default ImpuestosComplemento;
